import { Control, useController } from "react-hook-form";
import { Moment } from "moment";
import { getDateISO } from "@miplatform/utils";
import { DatePickerProps } from "@mui/x-date-pickers-pro";
import { DatePicker } from "../MiDatePicker/components/DatePicker";

export function MiControlledDatePicker({
  name,
  onChange: customOnChange,
  control,
  label,
  required,
  whiteBackground,
  ...props
}: Readonly<ControlledDatePickerProps<Moment>>) {
  const {
    field: { onChange, onBlur, value },
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  const handleChange = (dateMoment: Moment, ...args: any) => {
    onChange(dateMoment ? getDateISO(dateMoment) : null);

    if (customOnChange) {
      customOnChange(dateMoment, ...args);
    }
  };

  return (
    <DatePicker
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      error={error?.message}
      label={label}
      required={required}
      whiteBackground={whiteBackground}
      {...props}
    />
  );
}

interface ControlledDatePickerProps<T> extends DatePickerProps<T> {
  name: string;
  label: string;
  onChange?: (value: T | null, ...args: any) => void;
  control: Control<any>;
  required: boolean;
  whiteBackground?: boolean;
}
